import React from 'react';
import { Wrapper } from './HtmlRenderer.styles';

const HtmlRenderer = ({html}:{html: string}) => {
    return <Wrapper className='html-renderer' dangerouslySetInnerHTML={{__html: html}}></Wrapper>
}

export default HtmlRenderer;
